document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu toggle
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.getElementById('mobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.toggle('open');
    });
  }

  // AJAX add to cart
  var productForms = document.querySelectorAll('form[action^="/cart/add"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        // Update cart count
        return fetch('/cart.js');
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        } else {
          var cartLink = document.querySelector('.cart-link');
          if (cartLink) {
            var span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
        if (submitBtn) {
          submitBtn.textContent = 'Added to Cart';
          submitBtn.disabled = false;
          setTimeout(function() {
            submitBtn.textContent = originalText;
          }, 2000);
        }
      })
      .catch(function(error) {
        console.error('Error:', error);
        if (submitBtn) {
          submitBtn.textContent = 'Error - Try Again';
          submitBtn.disabled = false;
          setTimeout(function() {
            submitBtn.textContent = originalText;
          }, 2000);
        }
      });
    });
  });

  // Cart quantity update
  var cartInputs = document.querySelectorAll('.cart-item-quantity input');
  cartInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      var line = this.getAttribute('data-line');
      var quantity = this.value;
      var form = this.closest('form');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: parseInt(quantity) })
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Reload to update totals
        window.location.reload();
      });
    });
  });
});
